import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid';
import momentPlugin from '@fullcalendar/moment';
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import axios from 'axios';
import { getUrl, getJobTimeFormat, formatTrafficDate, getJobTimeBadge } from '../planner/planner';
import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import { Dropdown } from "primereact/dropdown";

export default function App(props) {
	const [data, setData] = useState([]);
	const [bookingsOption, setBookingsOption] = useState('all-bookings');
	const [dayBookings, setDayBookings] = useState([]);
	const [completeJobs, setCompletedJobs] = useState([]);
	const [incompleteJobs, setIncompleteJobs] = useState([]);
	const [orders, setOrders] = useState([]);
	const [editingEvent, setEditingEvent] = useState(null);
	const [availableSeconds, setAvailableSeconds] = useState(0);
	const [basicSeconds, setBasicSeconds] = useState(0);
	const [weeklyOrderData, setWeeklyOrderData] = useState([]);
	const [confirmedDateOrderDate, setConfirmedDateOrderData] = useState([]);
	const [weeklyEmployeeData, setWeeklyEmployeeData] = useState([]);
	const [orderSeconds, setOrderSeconds] = useState(0);
	const [travellerSeconds, setTravellerSeconds] = useState(0);
	const [weeklyTravellerData, setWeeklyTravellerData] = useState([]);
	const [orderDaySeconds, setOrderDaySeconds] = useState(0);
	const [confirmedSeconds, setConfirmedSeconds] = useState(0);
	const [bookingSeconds, setBookingsSeconds] = useState(0);
	const [employeeSeconds, setEmployeeSeconds] = useState(0);
	const [onDropEvent, setOnDropEvent] = useState(null);
	const [editDialog, setEditDialog] = useState(false);
	const [operatorDialog, setOpperatorDialog] = useState(false);
	const [isLoaded, setIsLoaded] = useState(false);
	const [operatorNumber, setOpperatorNumber] = useState(1);
	const [operatorTotal, setOperatorTotal] = useState(1);
	const [updateCalendar, setUpdateCalendar] = useState(false);
	const [confirmedRecordedTimes, setConfirmedRecordedTimes] = useState(0);
	const [currentCalendarView, setCurrentCalendarView] = useState('Week');

	useEffect(() => {
		if(props.bookingCategoryId && isLoaded == false) {
			axios.get(getUrl() + '/wp-json/planner/v1/bookings?category_id=' + props.bookingCategoryId, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }).then(res => {
				setWeeklyOrderData(res.data.weekly_total_order_target_times);
				setConfirmedDateOrderData(res.data.weekly_total_order_recorded_times);
				setWeeklyEmployeeData(res.data.weekly_total_employee_bookings);
				setWeeklyTravellerData(res.data.weekly_total_traveller_bookings);
				setData(res.data.bookable_travellers);
				setCompletedJobs(res.data.bookings_completed)
				setIncompleteJobs(res.data.bookings_incomplete)
				setDayBookings(res.data.bookings)

				setIsLoaded(true);

				if(!localStorage.getItem('bookingOption')) {
					setBookingsOption('all-bookings')
				} else {
					setBookingsOption(localStorage.getItem('bookingOption'))
				}
			}).catch(err => {
				console.log(err)
			});
		}

		let bookings = [];

		if(bookingsOption === 'all-bookings') {
			bookings = bookings.concat(incompleteJobs, completeJobs, dayBookings)
		} else if (bookingsOption === 'incomplete') {
			bookings = bookings.concat(incompleteJobs, dayBookings)
		} else if(bookingsOption === 'completed') {
			bookings = bookings.concat(completeJobs, dayBookings)
		}

		setOrders(bookings);

		const containerEl = document.querySelector("#events");

		if(props.currentLoggedInUser.length != 0) {
			if(props.currentLoggedInUser.capabilities.edit_bookings_travellers) {
				let draggable = new Draggable(containerEl, {
					itemSelector: ".event",
					eventData: (eventEl) => {
						return {
							id: eventEl.getAttribute('orderid'),
							title: eventEl.getAttribute('ordernumber'),
							duration: eventEl.getAttribute('eventduration'),
							backgroundColor: eventEl.getAttribute('eventcolor'),
							extendedProps: {
								travellerStatusLabel: eventEl.getAttribute('travellerStatusLabel'),
								companyDisplayName: eventEl.getAttribute('companydisplayname'),
								orderJobTime: eventEl.getAttribute('orderJobTime'),
							},
							borderColor: eventEl.getAttribute('eventcolor'),
							textColor: eventEl.getAttribute('eventtextcolor')
						};
					}
				});

				return () => {
					draggable.destroy()
				};
			}
		}
  }, [orderSeconds, props.bookingCategoryId, updateCalendar, bookingsOption]);

	function onDrop(info) {
		setOpperatorDialog(true);
		setOnDropEvent(info);
	}

	async function onResize(info) {
		setOrderSeconds((prevCount) => prevCount + Moment(info.event.end).diff(info.oldEvent.end, 'minutes'));

		await axios.put(getUrl() + '/wp-json/planner/v1/bookings/' + info.event.id, {
			date_to: Moment(info.event.end).format("YYYY-MM-DD HH:mm"),
			category_id: props.bookingCategoryId,
		}, {headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`}}).then(res => {
				setCompletedJobs(res.data.bookings_completed)
				setIncompleteJobs(res.data.bookings_incomplete)
				setWeeklyEmployeeData(res.data.weekly_total_employee_bookings);
				setWeeklyTravellerData(res.data.weekly_total_traveller_bookings);
			}
		).catch(err => console.log(err))

		setUpdateCalendar(Date());
	}

	async function onDrag(info) {
		await axios.put(getUrl() + '/wp-json/planner/v1/bookings/' + info.event.id, {
			date_to: Moment(info.event.end).format("YYYY-MM-DD HH:mm"),
			date_from: Moment(info.event.start).format("YYYY-MM-DD HH:mm"),
			category_id: props.bookingCategoryId,
		}, {headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`}}).then(res => {
			setCompletedJobs(res.data.bookings_completed)
			setIncompleteJobs(res.data.bookings_incomplete)
			setWeeklyEmployeeData(res.data.weekly_total_employee_bookings);
			setWeeklyTravellerData(res.data.weekly_total_traveller_bookings);
		}).catch(err => console.log(err));

		setUpdateCalendar(Date());
	}

	let badgeClasses = 'bg-success';

	if((availableSeconds - employeeSeconds) < orderSeconds) {
		badgeClasses = 'bg-danger';
	}

	async function saveEvent() {
		let startTime = Moment(onDropEvent.date).format("YYYY-MM-DD HH:mm");
		let endTime = Moment(onDropEvent.date).add(1, 'hours').format("YYYY-MM-DD HH:mm");
		let eventSeconds = orderSeconds;

		await axios.post(getUrl() + '/wp-json/planner/v1/bookings', {
			author_id: props.currentLoggedInUser.id,
			category_id: props.bookingCategoryId,
			date_from: startTime,
			date_to: endTime,
			operator_total: operatorNumber,
			user_id: props.currentLoggedInUser.id,
			traveller_id: onDropEvent.draggedEl.getAttribute('eventtravelerid'),
		}, {headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`}}).then(
			res => {
				setCompletedJobs(res.data.bookings_completed)
				setIncompleteJobs(res.data.bookings_incomplete)
				setWeeklyEmployeeData(res.data.weekly_total_employee_bookings);
				setWeeklyTravellerData(res.data.weekly_total_traveller_bookings);
			}
		).catch(err => console.log(err));

		let newEventSeconds = eventSeconds + (3600 * operatorNumber);
		setOrderSeconds(newEventSeconds);
		setOpperatorDialog(false);
		setOpperatorNumber(1);
	}

	function editBooking(event) {
		setEditingEvent(event);
		setEditDialog(true);
		setOperatorTotal(event.event.extendedProps.operatorTotal);
	}

	async function editEvent() {
		await axios.put(getUrl() + '/wp-json/planner/v1/bookings/' + editingEvent.event.id, {
			operator_total: operatorNumber,
			category_id: props.bookingCategoryId,
		}, {headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`}}).then(res => {
				setCompletedJobs(res.data.bookings_completed)
				setIncompleteJobs(res.data.bookings_incomplete)
				setWeeklyEmployeeData(res.data.weekly_total_employee_bookings);
				setWeeklyTravellerData(res.data.weekly_total_traveller_bookings);
			}
		).catch(err => console.log(err));

		setOpperatorNumber(1)
		setEditDialog(false)
		setUpdateCalendar(Date());
	}

	async function deleteBooking() {
		await axios.delete(getUrl() + '/wp-json/planner/v1/bookings/' + editingEvent.event.id, {headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`}, data: {category_id: props.bookingCategoryId,
		}}).then(			res => {
				setCompletedJobs(res.data.bookings_completed)
				setIncompleteJobs(res.data.bookings_incomplete)
				setWeeklyEmployeeData(res.data.weekly_total_employee_bookings);
				setWeeklyTravellerData(res.data.weekly_total_traveller_bookings);
			}
		).catch(err => console.log(err));

		setUpdateCalendar(Date());
		setEditingEvent(null);
		setEditDialog(false);
	}

	let loadingClass = 'isLoading';

	if(isLoaded) {
		loadingClass = 'notLoading';
	}

	document.title = 'Traveller Bookings - Planner';

	let calendarClasses = 'col-12 col-md-10';
	let bookableSidebar = 'd-block';

	if(data == null || data.length == 0) {
		calendarClasses = 'col-12';
		bookableSidebar = 'd-none';
	}

	let draggableClass = '';

	if(props.currentLoggedInUser.length != 0) {
		if(props.currentLoggedInUser.capabilities.edit_bookings_travellers) {
			draggableClass = ' draggable';
		}	
	}

	let availableEmployeeBadgeClass = 'bg-inputted';
	let remainingOrderBadgeClass = 'bg-inputted';

	if(isLoaded) {
		if(orderSeconds - travellerSeconds < 0) {
			remainingOrderBadgeClass = 'bg-danger'
		} else {
			remainingOrderBadgeClass = 'bg-success'
		}
	
		if((availableSeconds - employeeSeconds) - bookingSeconds < 0) {
			availableEmployeeBadgeClass = 'bg-danger'
		} else {
			availableEmployeeBadgeClass = 'bg-success'
		}
	
	}

	return (<>
		<Dialog blockScroll={true} header="Edit Booking" visible={editDialog} style={{ width: '25vw' }} draggable={false} onHide={(e) => setEditDialog(false)}>
			<div className="d-flex">
				<div className="flex-grow-1">
					<strong>Operators</strong>
					<InputNumber value={operatorTotal} onValueChange={(e) => setOpperatorNumber(e.value)} className="d-block operators-input" />
				</div>
			</div>
			<div className="d-flex mt-3">
				<Button type="button" label="Save Booking" icon="pi pi-send" onClick={editEvent} />
				<Button type="button" label="Delete Booking" icon="pi pi-trash" className="bg-danger ms-3" onClick={deleteBooking} />
			</div>
		</Dialog>

		<Dialog blockScroll={true} header="Add Booking" visible={operatorDialog} style={{ width: '25vw' }} closable={false} draggable={false}>
			<div className="d-flex">
				<div className="flex-grow-1">
					<strong>Operators</strong>
					<InputNumber value={operatorNumber} onValueChange={(e) => setOpperatorNumber(e.value)} className="d-block operators-input" />
				</div>
				<div className="d-flex">
					<div className="align-self-end">
						<Button type="button" label="Save Booking" icon="pi pi-send" className="ms-3" onClick={saveEvent} />
					</div>
				</div>
			</div>
		</Dialog>
		<div className="edit-order-bar position-sticky top-0 py-3 mb-0" >
			<div className="mx-5 px-0 d-flex justify-content-between align-items-center w-100" style={{maxWidth: "100%"}}>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex align-items-center">
						<div>
							<Button className="bg-primary p-2 me-3 d-flex align-items-center rounded d-xxl-none" onClick={e => {props.updateSidebarOpened(true);}}>
								<i className="pi pi-bars text-white" style={{ fontSize: '1.25rem' }}></i>
							</Button>
						</div>
						<div>
							<h1 className="mb-0 h3">Traveller Bookings</h1>
							<div>
							</div>
						</div>
					</div>
					<div className="text-end align-items-center d-flex">
						<div>
						<Dropdown
								options={[
									{ name: 'All Bookings', slug: 'all-bookings' },
									{ name: 'Incomplete Bookings', slug: 'incomplete' },
									{ name: 'Completed Bookings', slug: 'completed' },
								]}
								onChange={(e) => {setBookingsOption(e.value); localStorage.setItem('bookingOption', e.value)}}
								value={bookingsOption}
								optionLabel="name"
								optionValue="slug"
								className="me-4"
							/>
						</div>
						<div>
							<div className="mb-1">
								<strong>Total Employee Time: </strong><div className={"badge bg-dark text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(( availableSeconds - employeeSeconds ))}</div>
								<i className={"pi pi-info-circle total-employee-time ms-2"} style={{ fontSize: '0.9rem' }}></i>
								<Tooltip position="left" target=".total-employee-time">
									Basics hours accumulated with employee bookings deducted and incremented (Selected {currentCalendarView})
								</Tooltip>
							</div>
							<div>
								<strong>Available Employee Time: </strong>
								{
									isLoaded && (
										<>
											{
												( availableSeconds - employeeSeconds ) - bookingSeconds != ( availableSeconds - employeeSeconds ) && (
													<div className={"badge " + availableEmployeeBadgeClass + " text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(( availableSeconds - employeeSeconds ) - bookingSeconds)}</div>
												)
											}
											{
												( availableSeconds - employeeSeconds ) - bookingSeconds == ( availableSeconds - employeeSeconds ) && isLoaded && (
													<div className={"badge bg-danger text-white"}>Missing Bookings</div>
												)
											}
										</>
									)
								}
								{
									!isLoaded && (
										<div className={"badge " + availableEmployeeBadgeClass + " text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(( availableSeconds - employeeSeconds ) - bookingSeconds)}</div>
									)
								}
								<i className={"pi pi-info-circle available-employee-time ms-2"} style={{ fontSize: '0.9rem' }}></i>
								<Tooltip position="left" target=".available-employee-time">
									Traveller bookings accumulated and deducted from "Total Employee Time" (Selected {currentCalendarView})
								</Tooltip>
							</div>
						</div>
						<div className="ms-2">
							<div className="mb-1">
								<div>
							</div>
								<strong>Total Order Time: </strong>
								<div className={"badge bg-dark text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(orderSeconds)} </div>
								<i className={"pi pi-info-circle total-order-time ms-2"} style={{ fontSize: '0.9rem' }}></i>
								<Tooltip position="left" target=".total-order-time">
									Order target times accumulated (Selected {currentCalendarView})
								</Tooltip>
							</div>
							<div>
								<strong>Remaining Order Time: </strong>
								{
									isLoaded && (
										<>
										{
											travellerSeconds != 0  && (
												<div className={"badge " + remainingOrderBadgeClass + " text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(orderSeconds - travellerSeconds)}</div>
											)
										}
										{
											travellerSeconds == 0 && orderSeconds == 0 && (
												<div className={"badge bg-danger text-white"}>Missing Time</div>
											)
										}
										{
											travellerSeconds == 0 && orderSeconds != 0 && (
												<div className={"badge bg-danger text-white"}>Not Started</div>
											)
										}
										</>
									)
								}
								{
									isLoaded == false &&(
										<div className={"badge " + remainingOrderBadgeClass + " text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(orderSeconds - travellerSeconds)}</div>
									)
								}
								<i className={"pi pi-info-circle remaining-order-time ms-2"} style={{ fontSize: '0.9rem' }}></i>
								<Tooltip position="left" target=".remaining-order-time">
									Traveller recorded times accumulated and deducted from "Total Order Time" (Selected {currentCalendarView})
								</Tooltip>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		{
			!isLoaded && (
				<div className={"mx-5 mb-3 d-flex align-items-center justify-content-center h-100 w-100"} style={{ position: 'absolute', zIndex: '99999' }}>
					<i className="pi pi-spin pi-spinner" style={{ fontSize: '6rem', height: '6rem' }}></i>
				</div>
			)
		}
    <div className={"container-fluid px-5 mb-3 " + loadingClass}>
		<div className="row">
			<div className={calendarClasses}>
				<FullCalendar
					plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin]}
					initialView="timeGridWeek"
					events={orders}
					hiddenDays={[0, 6]}
					editable
					drop={onDrop}
					slotMinTime={"08:00"}
					slotMaxTime={"17:00"}
					eventDurationEditable={true}
					eventConstraint={'businessHours'}
					droppable
					headerToolbar= {{
						center: 'timeGridWeek,timeGridDay',
					}}
					contentHeight="auto"
					eventDrop={onDrag}
					eventResize={onResize}
					nextDayThreshold={'09:00'}
					weekNumbers={true}
					weekText="#"
					weekNumberFormat={
						{ week: 'narrow' }
					}
					slotLabelFormat={{
						hour: 'numeric',
						minute: '2-digit',
						omitZeroMinute: false,
						meridiem: false,
						hour12: false
					}}
					views={{
						timeGridWeek: {
							titleFormat: {
								month: 'long',
								day: '2-digit',
								year: 'numeric'
							},
							dayHeaderContent: (e) => {
								let travellerRecorded = 0;
								let travellersRecordedTimes = 0;
								let targetTime = 0;

								if(confirmedRecordedTimes[Moment(e.date).format('dddd')]) {
									travellerRecorded = confirmedRecordedTimes[Moment(e.date).format('dddd')];
								}

								if(confirmedSeconds[Moment(e.date).format('dddd')]) {
									travellersRecordedTimes = confirmedSeconds[Moment(e.date).format('dddd')];
								}

								if(orderDaySeconds[Moment(e.date).format('dddd')]) {
									targetTime = orderDaySeconds[Moment(e.date).format('dddd')];
								}

								let availableEmployeeBadgeClass = 'bg-success';
								let remainingOrderBadgeClass = 'bg-success';
							
								if(basicSeconds) {
									if((((basicSeconds.basic[Moment(e.date).format('dddd')]) - (basicSeconds.decrement[Moment(e.date).format('dddd')])) + (basicSeconds.increment[Moment(e.date).format('dddd')])) - travellerRecorded < 0) {
										remainingOrderBadgeClass = 'bg-danger'
									}
								}
							
								if(targetTime - travellersRecordedTimes < 0) {
									availableEmployeeBadgeClass = 'bg-danger'
								}
							
								return <div>{Moment(e.date).format('dddd Do')} <i className={"pi pi-info-circle header-" + Moment(e.date).format('dddd')} style={{ fontSize: '0.6rem' }}></i><div>{
										isLoaded && (
											<Tooltip position="top" target={".header-" + Moment(e.date).format('dddd')}>
											<div className="text-end">
												Total Employee Time: {basicSeconds.basic != undefined && getJobTimeBadge(((basicSeconds.basic[Moment(e.date).format('dddd')]) - (basicSeconds.decrement[Moment(e.date).format('dddd')])) + (basicSeconds.increment[Moment(e.date).format('dddd')]), false, "00:00:00")}
											</div>
											<div className="text-end">
												{
													travellerRecorded != 0 && (<>
														Available Employee Time: {basicSeconds.basic != undefined && getJobTimeBadge((((basicSeconds.basic[Moment(e.date).format('dddd')]) - (basicSeconds.decrement[Moment(e.date).format('dddd')])) + (basicSeconds.increment[Moment(e.date).format('dddd')])) - travellerRecorded, false, "00:00:00", remainingOrderBadgeClass)}
													</>)
												}
												{
													travellerRecorded == 0 && (<>
														Available Employee Time: <span className="bg-danger badge text-white">Missing Bookings</span>
													</>)
												}
											</div>
											<div className="text-end">
												Total Order Time: { orderDaySeconds != undefined && getJobTimeBadge(targetTime, false, "00:00:00")}
											</div>
											<div className="text-end">
												{
													travellersRecordedTimes != 0 && (<>
														Remaining Order Time: { orderDaySeconds != undefined && getJobTimeBadge(targetTime - travellersRecordedTimes, false, "00:00:00", availableEmployeeBadgeClass)}
													</>
													)
												}
												{
													travellersRecordedTimes == 0 && targetTime != 0 && (<>
														Remaining Order Time: <span className="bg-danger badge text-white">Not Started</span>
													</>
													)
												}
												{
													travellersRecordedTimes == 0 && targetTime == 0 && (<>
														Remaining Order Time: <span className="bg-danger badge text-white">Missing Time</span>
													</>
													)
												}
											</div>
										</Tooltip>
									)
								}</div></div>
							}
						},
						timeGridDay: {
							titleFormat: {
								month: 'long',
								day: '2-digit',
								year: 'numeric'
							},
							dayHeaderContent: (e) => {
								return <div>{Moment(e.date).format('dddd Do')}</div>
							}
						}
					}}
					businessHours={{
						daysOfWeek: [1, 2, 3, 4, 5, 6],
						startTime: '08:00',
						endTime: '17:00',
					}}
					allDayText=""
					datesSet={(arg) => {
						let calendarStartTime = Moment(arg.view.activeStart).startOf('isoweek').format('YYYY-MM-DD');
						let orderSeconds = 0;
						let bookedDaySeconds = 0;
						let employeeSeconds = 0;
						let confirmedDateSeconds = 0;
						let basicSeconds = 0;
						let basicAvailableSeconds = 0;
						let confirmedRecordedTimesDays = 0;
						let travellerBookingSeconds = 0;
						let bookingSeconds = 0;

						if(arg.view.type == 'timeGridWeek') {
							if(weeklyOrderData != null && weeklyOrderData.length != 0 && weeklyOrderData[calendarStartTime]) {
								orderSeconds = weeklyOrderData[calendarStartTime].secondsWeek;
								bookedDaySeconds = weeklyOrderData[calendarStartTime].secondsDays;
							}
	
							if(weeklyTravellerData != null && weeklyTravellerData.length != 0 && weeklyTravellerData[calendarStartTime]) {
								bookingSeconds = weeklyTravellerData[calendarStartTime].secondsWeek;
								confirmedRecordedTimesDays = weeklyTravellerData[calendarStartTime].secondsDays;
							}
	
							if(weeklyEmployeeData != null && weeklyEmployeeData.length != 0 && weeklyEmployeeData[calendarStartTime]) {
								employeeSeconds = weeklyEmployeeData[calendarStartTime].secondsWeek.decrement;
								basicSeconds = weeklyEmployeeData[calendarStartTime].secondsDays;
								basicAvailableSeconds = weeklyEmployeeData[calendarStartTime].secondsWeek.basic;
							} else if(weeklyEmployeeData != null && weeklyEmployeeData.length != 0) {
								basicSeconds = weeklyEmployeeData['default'].secondsDays;
								basicAvailableSeconds = weeklyEmployeeData['default'].secondsWeek.basic;
							}

							if(confirmedDateOrderDate != null && confirmedDateOrderDate.length != 0 && confirmedDateOrderDate[calendarStartTime]) {
								confirmedDateSeconds = confirmedDateOrderDate[calendarStartTime].secondsDays;
								travellerBookingSeconds = confirmedDateOrderDate[calendarStartTime].secondsWeek;
							}

							setAvailableSeconds(basicAvailableSeconds);
							setOrderDaySeconds(bookedDaySeconds);
							setBasicSeconds(basicSeconds);
							setOrderSeconds(orderSeconds);
							setTravellerSeconds(travellerBookingSeconds);
							setEmployeeSeconds(employeeSeconds);
							setConfirmedSeconds(confirmedDateSeconds);
							setConfirmedRecordedTimes(confirmedRecordedTimesDays);
							setBookingsSeconds(bookingSeconds);
							setCurrentCalendarView('Week');
						} 
 
						if(arg.view.type == 'timeGridDay') {
							let dayOfWeek = Moment(arg.view.activeStart).format('dddd');

							if(confirmedDateOrderDate != null && confirmedDateOrderDate.length != 0 && confirmedDateOrderDate[calendarStartTime]) {
								travellerBookingSeconds = confirmedDateOrderDate[calendarStartTime].secondsDays[dayOfWeek];
							}

							setTravellerSeconds(travellerBookingSeconds);

							if(weeklyOrderData != null && weeklyOrderData.length != 0 && weeklyOrderData[calendarStartTime]) {
								basicSeconds = weeklyOrderData[calendarStartTime].secondsDays[dayOfWeek];
							} else if(weeklyOrderData != null && weeklyOrderData.length != 0) {
								basicSeconds = weeklyOrderData['default'].secondsDays[dayOfWeek];
							}

							setOrderSeconds(basicSeconds);

							if(weeklyTravellerData != null && weeklyTravellerData.length != 0 && weeklyTravellerData[calendarStartTime]) {
								bookingSeconds = weeklyTravellerData[calendarStartTime].secondsDays[dayOfWeek];
							}

							setBookingsSeconds(bookingSeconds);

							if(weeklyEmployeeData != null && weeklyEmployeeData.length != 0 && weeklyEmployeeData[calendarStartTime]) {
								employeeSeconds = weeklyEmployeeData[calendarStartTime].secondsDays.decrement[dayOfWeek];
								basicAvailableSeconds = weeklyEmployeeData[calendarStartTime].secondsDays.basic[dayOfWeek];
							} else if(weeklyEmployeeData != null && weeklyEmployeeData.length != 0) {
								basicAvailableSeconds = weeklyEmployeeData['default'].secondsDays.basic[dayOfWeek];
							}

							setAvailableSeconds(basicAvailableSeconds);
							setEmployeeSeconds(employeeSeconds);
							setCurrentCalendarView('Day');
						}
					}}
					slotDuration={'00:10:00'}
					firstDay={1}
					nowIndicator={true}
					eventContent={(event) => {
						let pencilHoverClass = 'dark-hover';
						let statusBadge = 'badge text-light border border-light';

						if(event.event.textColor === '#000000') {
							pencilHoverClass = 'light-hover';
							statusBadge = 'badge text-dark border border-dark';
						}

						let timerColorClass = 'bg-dark';

						if(event.event.extendedProps.orderJobTime === '00:00:00') {
							timerColorClass = 'bg-danger';
						}

						return(<>
							{
								event.isDraggable !== false && (
									<div className="d-flex align-items-center mx-1">
										<div onClick={(e) => editBooking(event)} className={"delete-button me-1 " + pencilHoverClass}><i className="pi pi-pencil" style={{ color: event.event.textColor, fontSize: '0.55rem' }}></i></div>
										<strong>{event.event.title}</strong>
									</div>
								)
							}
							<div className="m-1">
								{
									event.isDraggable === false && (
										<div>{event.event.title}</div>
										
									)
								}
								<div className="d-flex align-items-center my-1"><small className={statusBadge}>{event.event.extendedProps.travellerStatusLabel}</small><small className="ms-1">{event.timeText}</small></div>
								{
									event.event.extendedProps.orderNumber && (
										<div className="d-flex align-items-center my-1">
											<small className="d-block me-1">Sales Order #{event.event.extendedProps.orderNumber}</small>
											{
												event.event.extendedProps.confirmedDate && (
													formatTrafficDate(event.event.extendedProps.confirmedDate)
												)
											}
											{
												!event.event.extendedProps.confirmedDate && (
													<span className={"badge bg-danger text-white me-2"}>Missing Date</span>
												)
											}
										</div>
									)
								}
								{
									event.event.extendedProps.companyDisplayName && event.event.extendedProps.orderStatusLabel && (
										<div className="d-flex align-items-center">
											<small className={statusBadge}>{event.event.extendedProps.orderStatusLabel}</small>
											<small className="d-block text-break ms-1" style={{whiteSpace: 'normal'}}>{event.event.extendedProps.companyDisplayName}</small>
										</div>
									)
								}
								{
									event.event.extendedProps.companyDisplayName && !event.event.extendedProps.orderStatusLabel && (
										<small className="d-block my-1 text-break" style={{whiteSpace: 'normal'}}>{event.event.extendedProps.companyDisplayName}</small>
									)
								}
								{
									event.event.extendedProps.productSku && event.event.extendedProps.productQty && (
										<div className="d-flex my-1" style={{ fontSize: '0.7rem' }}>
											{event.event.extendedProps.productSku} <div className="mx-1">x</div> <div><span className="badge bg-primary">{event.event.extendedProps.productQty}</span></div>
										</div>
									)
								}
								{
									(event.event.extendedProps.travellerTargetTime && event.event.allDay != true) && (
										<div className="flex align-items-center">
											<span className={timerColorClass + " badge text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(event.event.extendedProps.travellerTargetTime)}</span>&nbsp;<span><i className="pi pi-user" style={{ fontSize: '0.7rem' }}></i> <small>x {event.event.extendedProps.operatorTotal}</small></span>
										</div>
									)
								}
								{
									(!event.event.extendedProps.travellerTargetTime && event.event.allDay != true) && (
										<div className="flex align-items-center">
											<span className={"bg-danger badge text-white"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>Missing Time</span>&nbsp;<span><i className="pi pi-user" style={{ fontSize: '0.7rem' }}></i> <small>x {event.event.extendedProps.operatorTotal}</small></span>
										</div>
									)
								}
							</div>
						</>)
					}}
				/>
			</div>
			<div className={"col-12 col-md-2 mt-3 mt-md-0 " + bookableSidebar} style={{paddingTop: '1em'}}>
				<ul id="events" className={"d-flex p-0 flex-wrap " + draggableClass}>
					{
						data != null && data.length != 0 && (
							data.map(item => {
								let timerColorClass = 'bg-dark';

								let statusBadge = 'badge text-light border border-light';

								if(item.textColor === '#000000') {
									statusBadge = 'badge text-dark border border-dark';
								}

								if(item.extendedProps.orderJobTime === '00:00:00') {
									timerColorClass = 'bg-danger';
								}

								return (<li key={item.extendedProps.travellerId} orderid={item.extendedProps.orderId} ordernumber={item.title} productSku={item.extendedProps.productSku} companydisplayname={item.extendedProps.companyDisplayName} orderJobTime={item.extendedProps.orderJobTime} travellerStatusLabel={item.extendedProps.travellerStatusLabel} eventtextcolor={item.textColor} className={"event badge d-block mb-2 me-2 fw-normal"} eventcolor={item.backgroundColor} style={{backgroundColor: item.backgroundColor, color: item.textColor}} eventtravelerid={item.extendedProps.travellerId}>
									<div className="d-flex justify-content-between">
										<strong>{item.title}</strong>
										{
											item.extendedProps.travellerBooked != false && (
												<div>
													<i className="pi pi-check" style={{ fontSize: '0.6rem' }}></i>
												</div>
											)
										}
									</div>
									<div className="my-1"><small className={statusBadge}>{item.extendedProps.travellerStatusLabel}</small></div>
									<div className="d-flex">
									<span className="me-1">Sales Order #{item.extendedProps.orderNumber}</span>
									{
										item.extendedProps.confirmedDate && (
											formatTrafficDate(item.extendedProps.confirmedDate)
										)
									}
									{
										!item.extendedProps.confirmedDate && (
											<span className={"badge bg-danger text-white me-2"}>Missing Date</span>
										)
									}
									</div>
									<small style={{fontSize: '0.6rem'}}>{item.extendedProps.companyDisplayName}</small>
									{
									item.extendedProps.productSku && item.extendedProps.productQty && (
											<div className="d-flex font-weight-normal" style={{ fontSize: '0.7rem' }}>
												{item.extendedProps.productSku} <div className="mx-1">x</div> <div><span className="badge bg-primary">{item.extendedProps.productQty}</span></div>
											</div>
										)
									}
									{
										item.extendedProps.travellerTargetTime && (
											<div className="mt-1 d-flex">
												<span className={timerColorClass + " badge text-white me-2"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>{getJobTimeFormat(item.extendedProps.travellerTargetTime)}</span>
											</div>
										)
									}
									{
										!item.extendedProps.travellerTargetTime && (
											<div className="mt-1 d-flex">
												<span className={"badge bg-danger text-white me-2"}><i className="pi pi-stopwatch me-1" style={{ fontSize: '0.65rem' }} ></i>Missing Time</span>
											</div>
										)
									}
								</li>)
							})	
						)
					}
				</ul>
			</div>
		</div>
    </div>
	</>);
}
